import type { Grid2 as Grid } from '@mui/material';
import type { ComponentProps } from 'react';
import { FootNote } from '@/pages/ValuationsV2/components/FootNote';
import { useValuationsStore } from '@/pages/ValuationsV2/store/valuationsStore';
import { Metric } from '../Metric';
import { SummaryCardContentGrid, SummaryCardFooter } from '../SummaryCardContentGrid';
import { useProductionAndReservesMetrics } from './useProductionAndReservesMetrics';

const ProductionAndReservesView = ({ ...props }: ComponentProps<typeof Grid>) => {
  const selectedAssetDetails = useValuationsStore.use.selectedAssetDetails();
  const { metrics, notes } = useProductionAndReservesMetrics(selectedAssetDetails);

  if (metrics.length === 0) {
    return null;
  }

  return (
    <>
      <SummaryCardContentGrid {...props} data-id='production-and-reserves-view'>
        {metrics.map(metric => (
          <Metric
            key={metric.label}
            label={metric.label}
            value={metric.value}
            {...(metric.unit ? { unit: metric.unit } : {})}
          />
        ))}
      </SummaryCardContentGrid>
      {notes ? (
        <SummaryCardFooter data-id='production-and-reserves-footnotes'>
          <FootNote data-id='production-and-reserves-footnote'>{notes}</FootNote>
        </SummaryCardFooter>
      ) : null}
    </>
  );
};

export { ProductionAndReservesView };
